import { useEffect } from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  useEffect(() => {
    document.body.classList.add("authentication-basic");
    return () => {
      document.body.classList.remove("authentication-basic");
    };
  }, []);

  return (
    <div className="container">
      <div className="row justify-content-center align-items-center authentication authentication-basic h-100">
        <div className="col-xxl-5 col-xl-5 col-lg-6 col-md-8 col-sm-10 col-12">
          <div className="card custom-card my-4">
            <div className="card-body p-5 text-center">

              {/* Logo */}
              <div className="mb-4 d-flex justify-content-center">
                <Link to="/">
                  <img
                    src="assets/images/brand-logos/desktop-logo.png"
                    alt="logo"
                    className="desktop-logo"
                  />
                  <img
                    src="assets/images/brand-logos/desktop-white.png"
                    alt="logo"
                    className="desktop-white"
                  />
                </Link>
              </div>

              {/* Ghost icon */}
              <div
                className="mb-3"
                style={{ animation: "float 3s ease-in-out infinite", display: "inline-block" }}
              >
                <i className="ri-ghost-line" style={{ fontSize: 64, opacity: 0.15 }} />
              </div>

              {/* 404 */}
              <p className="mb-1" style={{ fontSize: 88, fontWeight: 600, lineHeight: 1, letterSpacing: -3 }}>
                4<span style={{ opacity: 0.15 }}>0</span>4
              </p>

              {/* Title */}
              <p className="h5 mb-2">Page not found</p>

              {/* Description */}
              <p className="text-muted mb-4">
                The page you're looking for doesn't exist or may have been
                moved. Double-check the URL or return to the homepage.
              </p>

              {/* Search hint */}
              <div
                className="d-inline-flex align-items-center gap-2 mb-4 px-3 py-2 rounded text-muted"
                style={{
                  background: "rgba(128,128,128,0.08)",
                  border: "1px solid rgba(128,128,128,0.15)",
                  fontSize: 13,
                }}
              >
                <i className="ri-search-line" />
                <span>Try searching for what you need</span>
              </div>

              {/* Buttons */}
              <div className="d-grid gap-2">
                <Link to="/" className="btn btn-primary">
                  <i className="ri-home-line align-middle me-1" />
                  Back to home
                </Link>
              </div>

            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50%       { transform: translateY(-10px); }
        }
      `}</style>
    </div>
  );
};

export default NotFound;